import { TestCardContainer, TestVerifyResultStyles } from '@Src/_basic/components/MuiStyleComponent/TestComponent';
import ColFieldInfo from '@Src/_basic/components/YatungTest/ColFieldInfo';
import EditButtons from '@Src/_basic/components/YatungTest/EditButtons';
import TestTable from '@Src/_basic/components/YatungTest/TestTable';
import { checkIsNaN } from '@Src/_basic/helpers/CheckIsNaN';
import { formatNumber } from '@Src/_basic/helpers/FormatNumber';
import { basicNumberSchema } from '@Src/_basic/helpers/TestForm';
import { AllTest } from '@Src/_basic/object/TestType';
import {
  FlyAshSlump,
  ImportFlyAshSlump,
  PutFlyAshSlumpRequest,
} from '@Src/_basic/object/test/cementtitiousPowder/FlyAshSlumpType';
import { TestApi } from '@Src/_basic/protocol/test/TestApi';
import LabelInput from '@Src/app/module/proportionManage/components/LabelInput';
import { Stack } from '@mui/material';
import { useFormik } from 'formik';
import React, { ChangeEvent, memo, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

interface Props {
  testDetail: FlyAshSlump;
  // eslint-disable-next-line no-unused-vars
  afterUpdateTest: (test: AllTest) => void;
  canEdit?: boolean;
}

const validationSchema = Yup.object().shape({
  slump: basicNumberSchema,
});

function ExportFlyAshLValueTable({ testDetail, afterUpdateTest, canEdit }: Props) {
  const { t: i18T } = useTranslation();

  const [edit, setEdit] = useState<boolean>(false);

  const initialValues = useMemo(
    () => ({
      slump: testDetail?.slump,
    }),
    [testDetail],
  );

  const otherInfo = useMemo(
    () => [
      {
        title: formatNumber(testDetail?.slump?.toFixed(2)),
      },
    ],
    [testDetail],
  );

  const firstHeader = useMemo(
    () => ({
      title: `${i18T(`TEST.FLY_ASH_SLUMP_TEST.SLUMP`)}(cm)`,
    }),
    [i18T],
  );

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      const data: ImportFlyAshSlump = {
        slump: checkIsNaN(+values.slump),
      };

      TestApi.putTest<PutFlyAshSlumpRequest>(
        {
          exptItemCode: testDetail.exptItemCode,
          fields: {
            ...testDetail,
            ...data,
          },
        },
        (_data) => {
          afterUpdateTest(_data);
          setEdit(false);
        },
        (err) => console.log(err),
      );
    },
  });

  const slumpView = useMemo(() => {
    switch (edit) {
      case true:
        return (
          <ColFieldInfo
            titleStyle={{ ...TestVerifyResultStyles.resultTitle, borderBottom: '1px solid #ccc', paddingBottom: 20 }}
            title={`${i18T(`TEST.FLY_ASH_SLUMP_TEST.SLUMP`)}(cm)`}
          >
            <LabelInput
              valueWidth="150px"
              value={formik.values.slump}
              isError={!!(formik.touched.slump && formik.errors.slump)}
              onChange={(e: ChangeEvent<HTMLInputElement>) => formik.setFieldValue('slump', e.target.value)}
            />
          </ColFieldInfo>
        );
      case false:
        return <TestTable headerData={firstHeader} rows={otherInfo} />;
      default:
        break;
    }
  }, [edit, formik, firstHeader, otherInfo, i18T]);

  return (
    <Stack gap={2}>
      <TestCardContainer>
        <EditButtons edit={edit} setEdit={setEdit} onSubmit={formik.handleSubmit} canEdit={canEdit} />
        {slumpView}
      </TestCardContainer>
    </Stack>
  );
}

export default memo(ExportFlyAshLValueTable);
